const formatPrice = (value = 0, isCents = false, withCurrency = true, toFixed = 2) => {
  const modifier        = value < 0 ? '- ' : ''
  const formattedValue  = (Math.abs(value) / (isCents ? 100 : 1)).toFixed(toFixed)
  const currency        = withCurrency ? '$' : ''

  return `${modifier}${currency}${formattedValue}`
}


export default formatPrice
